te<template>
    <div class="twoBannerHome wow fadeInAnimated fadeIn">
        <div class="borderTop">
            <div class="title">
                <img :src="haojobLogo" alt="">
                <ul class="tabItem">
                    <li @click="$router.push('/')">首页</li>
                    <li @click="$router.push('/investment')" class="active">招商加盟</li>
                    <li @click="$router.push('/downloadApp')">APP下载</li>
                    <li @click="$router.push('/relationPages')">联系我们</li>
                    <li style="width: 100px;height: 35px;background: #FFFFFF;border: 1px solid #1D5EEA;line-height:35px;text-align: center;margin-top:22.5px;padding:0;"><a style="color:#1D5EEA;text-decoration: none;" href="http://consoletwo.lielanghr.com/#/login">劳务登录</a></li>
                </ul>
            </div>
        </div>
        <div class="centerFloat">
            <div class="newsCenter">
                <div class="titleDyanc"><span @click="$router.push('/newsDynamic')" style="cursor:pointer;">新闻动态</span> > 新闻详情</div>
                <div class="newDetail">
                    <p>{{newDetailData.tutorialTitle}}</p>
                    <span class="time">{{getTime(newDetailData.showStartTime,'分')}}</span>
                    <div v-html="newDetailData.tutorialContent" class="newcontent"></div>
                </div>
                <div class="newRight">
                    <p>推荐文章</p>
                    <ul v-for="(item,index) in newListData" :key="index" @click="sendNew(item.id)">
                        <li>{{item.tutorialTitle}}</li>
                        <li>{{getTime(newDetailData.showStartTime,'分')}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <footerPages :backColor="'#3A3D53'" :borderBottom="'1px solid #626475'"></footerPages>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
import haojobLogo from '@/assets/haoojoblogo.svg'
import api from '@/api'

export default {
    data(){
        return {
            haojobLogo,
            newDetailData:'',
            newListData:'',
            query:{
                pageNum:1,
                pageSize:5
            }
        }
    },
    mounted () {
        let wow = new WOW({
                boxClass: 'wow',
                animateClass: 'animated',
                offset: 0,
                mobile: true
        })
        window.scroll(0, 0)
        wow.init();
    },
    methods:{
        getTime(time,type) {
            var y = new Date(time).getFullYear();
            var m = new Date(time).getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = new Date(time).getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = new Date(time).getHours();
            var minute = new Date(time).getMinutes();
            minute = minute < 10 ? ('0' + minute) : minute;
            if(type=='分'){
            return y + '-' + m + '-' + d+' '+h+':'+minute;
            }else if(type=='月'){
            return y + '-' + m + '-'
            }else if(type=='日'){
            return y + '-' + m + '-' + d
            }
        },
        async initData(){
            let resData = await api.newList(this.query)
            this.newListData=resData.content;

            let id = window.location.href.split('newDetail/')[1]
            let query = {
                messageTutorialId:id
            }
            let res = await api.newDetail(query)
            this.newDetailData = res;
        },  
        sendNew(id){
            window.scroll(0, 0)
            this.$router.push(`/newDetail/${id}`)
            this.initData()
        }
    },
    created(){
        this.initData()
        console.log(323)
    }
}
</script>
<style src='@/pages/components/publicStyle/animated.css' scoped></style>
<style scoped lang="less">
    .borderTop{
        width: 100%;
        height: auto;
        overflow: hidden;
        background:rgba(255,255,255,1);
        border-bottom: 1px solid #EEF0F4;
    }

    .centerFloat{
        width: 100%;
        height: auto;
        background: #fff;
        overflow: hidden;
        box-sizing: border-box;
        margin-bottom: 30px;
        .newsCenter{
            width: 1200px;
            height: auto;
            overflow: hidden;
            margin: 0 auto;
            padding-top: 20px;
            box-sizing: border-box;
            .titleDyanc{
                font-size:14px;
                font-weight:400;
                color:rgba(203,203,203,1);
                line-height:36px;
            }
            .newDetail{
                float: left;
                width: 800px;
                height: auto;
                overflow: hidden;
                p{
                    font-size:36px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:40px;
                    padding-top: 80px;
                    box-sizing: border-box;
                }
                .time{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:36px;
                    padding-top: 20px;
                }
                .newcontent{
                    font-size: 16px;
                    color: #666666;
                    margin-top: 55px;
                }
            }
            .newRight{
                width:330px;
                height:548px;
                background:rgba(255,255,255,1);
                border:1px solid rgba(203, 203, 203, 1);
                float: right;
                padding: 30px;
                box-sizing: border-box;
                p{
                    font-size:16px;
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                    line-height:23px;
                    margin-bottom: 30px;
                }
                ul{
                    width: 100%;
                    height: auto;
                    margin-bottom: 20px;
                    cursor: pointer;
                    li:first-child{
                        width: 100%;
                        font-size:16px;
                        font-weight:400;
                        color:rgba(102,102,102,1);
                        line-height:23px;
                        word-break:break-all;
                        display:-webkit-box;/**对象作为伸缩盒子模型展示**/
                        -webkit-box-orient:vertical;/**设置或检索伸缩盒子对象的子元素的排列方式**/
                        -webkit-line-clamp:2;/**显示的行数**/
                        overflow:hidden;
                    }
                    li:last-child{
                        font-size:12px;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        line-height:23px;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 1024px) {
        .centerFloat{
            margin-bottom: 16px;
            .newsCenter{
                width: 640px;
                padding-top: 15px;
                .titleDyanc{
                    font-size: 7px;
                    line-height: 19px;
                }
                .newDetail{
                    width: 427px;
                    p{
                        font-size: 19px;
                        line-height: 21px;
                        padding-top: 48px;
                    }
                    .time{
                        font-size:7px;
                        line-height: 19px;
                        padding-top: 13px;
                    }
                    .newcontent{
                        font-size: 9px;
                        margin-top: 30px;
                    }
                }
                .newRight{
                    width: 176px;
                    padding: 20px;
                    height: 310px;
                    p{
                        font-size:9px;
                        line-height:12px;
                        margin-bottom: 16px;
                    }
                    ul{
                        margin-bottom: 16px;
                        li:first-child{
                            font-size: 9px;
                            line-height: 12px;
                        }
                        li:last-child{
                            font-size:6px;
                            line-height: 12px;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1100px) and (min-width: 1024px) {
        .centerFloat{
            margin-bottom: 17px;
            .newsCenter{
                width: 688px;
                padding-top: 17px;
                .titleDyanc{
                    font-size: 8px;
                    line-height: 21px;
                }
                .newDetail{
                    width: 458px;
                    p{
                        font-size: 21px;
                        line-height: 23px;
                        padding-top: 52px;
                    }
                    .time{
                        font-size:8px;
                        line-height: 21px;
                        padding-top: 14px;
                    }
                    .newcontent{
                        font-size: 9px;
                        margin-top: 34px;
                    }
                }
                .newRight{
                    width: 189px;
                    padding: 23px;
                    height: 335px;
                    p{
                        font-size:9px;
                        line-height:13px;
                        margin-bottom: 17px;
                    }
                    ul{
                        margin-bottom: 17px;
                        li:first-child{
                            font-size: 9px;
                            line-height: 13px;
                        }
                        li:last-child{
                            font-size: 7px;
                            line-height: 13px;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1280px) and (min-width: 1100px) {
        .centerFloat{
            margin-bottom: 20px;
            .newsCenter{
                width: 800px;
                padding-top: 19px;
                .titleDyanc{
                    font-size: 9px;
                    line-height: 24px;
                }
                .newDetail{
                    width: 533px;
                    p{
                        font-size: 24px;
                        line-height: 26px;
                        padding-top: 60px;
                    }
                    .time{
                        font-size:9px;
                        line-height: 24px;
                        padding-top: 16px;
                    }
                    .newcontent{
                        font-size: 11px;
                        margin-top: 35px;
                    }
                }
                .newRight{
                    width: 220px;
                    padding: 27px;
                    height: 390px;
                    p{
                        font-size:11px;
                        line-height:15px;
                        margin-bottom: 20px;
                    }
                    ul{
                        margin-bottom: 20px;
                        li:first-child{
                            font-size: 11px;
                            line-height: 15px;
                        }
                        li:last-child{
                            font-size: 8px;
                            line-height: 15px;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1366px) and (min-width: 1280px) {
        .centerFloat{
            margin-bottom: 21px;
            .newsCenter{
                width: 854px;
                padding-top: 21px;
                .titleDyanc{
                    font-size: 10px;
                    line-height: 26px;
                }
                .newDetail{
                    width: 569px;
                    p{
                        font-size: 26px;
                        line-height: 28px;
                        padding-top: 64px;
                    }
                    .time{
                        font-size:10px;
                        line-height: 26px;
                        padding-top: 17px;
                    }
                    .newcontent{
                        font-size: 11px;
                        margin-top: 40px;
                    }
                }
                .newRight{
                    width: 235px;
                    padding: 29px;
                    height: 420px;
                    p{
                        font-size:11px;
                        line-height:16px;
                        margin-bottom: 21px;
                    }
                    ul{
                        margin-bottom: 21px;
                        li:first-child{
                            font-size: 11px;
                            line-height: 16px;
                        }
                        li:last-child{
                            font-size: 9px;
                            line-height: 16px;
                        }
                    }
                }
            }
        }
    }   

    @media only screen and (max-width: 1440px) and (min-width: 1366px) {
        .centerFloat{
            margin-bottom: 23px;
            .newsCenter{
                width: 900px;
                padding-top: 22px;
                .titleDyanc{
                    font-size: 11px;
                    line-height: 27px;
                }
                .newDetail{
                    width: 600px;
                    p{
                        font-size: 27px;
                        line-height: 29px;
                        padding-top: 68px;
                    }
                    .time{
                        font-size:11px;
                        line-height: 27px;
                        padding-top: 18px;
                    }
                    .newcontent{
                        font-size: 12px;
                        margin-top: 40px;
                    }
                }
                .newRight{
                    width: 248px;
                    height: 445px;
                    padding: 31px;
                    p{
                        font-size:12px;
                        line-height:17px;
                        margin-bottom: 23px;
                    }
                    ul{
                        margin-bottom: 23px;
                        li:first-child{
                            font-size: 12px;
                            line-height: 17px;
                        }
                        li:last-child{
                            font-size: 9px;
                            line-height: 17px;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1680px) and (min-width: 1440px) {
        .centerFloat{
            margin-bottom: 26px;
            .newsCenter{
                width: 1050px;
                padding-top: 25px;
                .titleDyanc{
                    font-size: 12px;
                    line-height: 32px;
                }
                .newDetail{
                    width: 700px;
                    p{
                        font-size: 32px;
                        line-height: 34px;
                        padding-top: 79px;
                    }
                    .time{
                        font-size:12px;
                        line-height: 32px;
                        padding-top: 21px;
                    }
                    .newcontent{
                        font-size: 14px;
                        margin-top: 50px;
                    }
                }
                .newRight{
                    width: 289px;
                    padding: 36px;
                    height: 520px;
                    p{
                        font-size:14px;
                        line-height:20px;
                        margin-bottom: 26px;
                    }
                    ul{
                        margin-bottom: 26px;
                        li:first-child{
                            font-size: 14px;
                            line-height: 20px;
                        }
                        li:last-child{
                            font-size: 11px;
                            line-height: 20px;
                        }
                    }
                }
            }
        }
    }   
</style>